import React, { useState, useEffect, useContext } from "react";
import Image from "react-bootstrap/Image";

import Logo from "../../images/newimg/newlogo.svg";
import Logo2 from "../../images/therapist_logo.png";

import Form from "react-bootstrap/Form";
import FlagIcon from "../../images/flagus.png";
import "react-phone-input-2/lib/style.css";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import GoogleLogo from "../../images/google.png";
import FacebookLogo from "../../images/facebook.png";
import AppleLogo from "../../images/apple.png";
import LoginBg from "../../images/newimg/login.jpg";
import Loader from "../../common/Loader";
import { useGoogleLogin } from "@react-oauth/google";
// import FacebookLogin from "react-facebook-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import axios from "axios";
import Functions from "../../../utility/services/Functions";
import ApiService from "../../../utility/services/ApiService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ValidationsService } from "../../../utility/services/ValidationsService";
import { AuthContext } from "../../../utility/services/AuthContext";
import AppleLogin from "react-apple-login";
import Modal from "react-bootstrap/Modal";
import { trackScreenView, trackButtonClick, trackEvent } from "../../../utility/services/analyticsService";

const Login = () => {
  // DATA VARIABLES

  const [phone, setPhone] = useState("");

  // LOGICAL VARIABLES

  const [loading, setLoading] = useState(false);
  const [validationsRes, setValidationsRes] = useState({});

  const authContext = useContext(AuthContext);
  const authUserRole = authContext.authUserRole;
  const isRoleTherapist = authUserRole == "Therapist";
  const { consoleService, enctyptDataFun } = Functions();
  const { send_otp, social_login, check_user_role_auth } = ApiService();
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [loginType, setLoginType] = useState();
  const [show_delete_info_modal, setShowDeleteInfoModal] = useState(false);
  const [delete_info_modal_text, setDeleteInfoModalText] = useState("");
  const [social_data_for_delete_info, setSocialDataForDeleteInfo] =
    useState(null);
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.log("Login Failed:", error),
  });

  // USE EFFECTS

  useEffect(() => {
    trackScreenView("login_screen", { screen_name: "Login", user_role: authUserRole });
    // const encryptedData = CryptoJS.AES.encrypt(
    //   JSON.stringify("this is testing data"),
    //   "s1234323"
    // ).toString();
    if (!authUserRole) return navigate("/", { replace: true });
    const handleBackButtonPress = () => {
      // Execute your function when the back button is pressed
      navigate("/", { replace: true });
    };

    const disableBackAndForwardNavigation = () => {
      window.history.pushState(null, null, window.location.href);
      window.addEventListener("popstate", handleBackButtonPress);
    };

    disableBackAndForwardNavigation();

    return () => {
      window.removeEventListener("popstate", handleBackButtonPress);
    };
  }, []);

  useEffect(() => {
    validationsResFun();
  }, [phone]);

  useEffect(() => {
    if (loginType == "google") {
      if (Object.keys(user).length > 0) {
        axios
          .get(
            `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
            {
              headers: {
                Authorization: `Bearer ${user.access_token}`,
                Accept: "application/json",
              },
            }
          )
          .then((res) => {
            socialLogin_fun(res.data);
          })
          .catch((err) => console.log(err));
      }
    } else if (loginType == "facebook") {
      socialLogin_fun(user);
    } else if (loginType == "apple") {
      socialLogin_fun(user);
    }
  }, [user]);

  async function socialLogin_fun(data) {
    const socialData = data;
    const isAppleLogin = loginType == "apple";
    const isFacebookLogin = loginType == "facebook";
    socialData.loginType = loginType;
    socialData.apple_id = isAppleLogin ? socialData.authorization.id_token : "";
    socialData.facebook_id = isFacebookLogin ? socialData.userID : "";

    setLoading(true);
    let searchQuery;
    let query_type;
    if (isAppleLogin) {
      searchQuery = socialData.apple_id;
      query_type = "apple";
    } else if (isFacebookLogin) {
      searchQuery = socialData.facebook_id;
      query_type = "facebook";
    } else {
      searchQuery = socialData.email;
      query_type = "email";
    }
    try {
      const data = {
        role: authUserRole,
        searchQuery: searchQuery,
        device_token: "",
        query_type: query_type,
      };
      const res = await social_login(data);

      if (res.status === 1) {
        const { userExist, profile_approve_status, is_profile_submitted } =
          res.data;
        if (authUserRole == "Therapist") {
          if (!userExist) {
            navigate("/therapistregisteration", {
              state: { socialData, navigateFrom: "LoginScreen" },
              replace: true,
            });
          } else if (
            userExist &&
            !is_profile_submitted &&
            !is_profile_submitted
          ) {
            navigate("/therapistcompleteprofile", {
              state: res.data.user_id,
              replace: true,
            });
          } else if (
            userExist &&
            !profile_approve_status &&
            is_profile_submitted
          ) {
            toast(
              "Your profile request is pending for approval. Please try again later",
              {
                position: "top-center",
                hideProgressBar: true,
                type: "error",
              }
            );
          } else {
            trackEvent("login", { event_type: "logged_in", method: loginType, user_role: authUserRole, user_name: socialData.name, email: socialData.email });
            localStorage.setItem("E_C_U_A_T", enctyptDataFun(res.data.token));

            authContext.setUser({
              ...authContext.user,
              access_token: res.data.token,
            });
            navigate("/dashboard", { replace: true });
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
        } else {
          if (!userExist) {
            navigate("/patientregisteration", {
              state: { socialData, navigateFrom: "LoginScreen" },
              replace: true,
            });
          } else {
            trackEvent("login", { event_type: "logged_in", method: loginType, user_role: authUserRole, user_name: socialData.name, email: socialData.email });
            localStorage.setItem("E_C_U_A_T", enctyptDataFun(res.data.token));

            authContext.setUser({
              ...authContext.user,
              access_token: res.data.token,
            });
            navigate("/dashboard", { replace: true });
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
        }
      } else if (res.status === 2) {
        handel_delete_status(res.message, socialData);
      } else {
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      consoleService("error in send otp function", err);
    }
  }

  const responseFacebook = (response) => {
    if (!response.userID) return;
    setLoginType("facebook");
    setUser(response);
    window.FB.logout();
  };

  //////////////////////////  FUNCTIONS  //////////////////////////////

  function validationsResFun() {
    setValidationsRes(ValidationsService({ phone }));
  }

  const send_otp_function = async () => {
    trackButtonClick("login_cta", { button_name: "Login", user_role: authUserRole, method: "phone", phone: `+1${phone.trim()}` });
    setLoading(true);
    try {
      const modifiedPhone = `+1${phone.trim()}`;

      const data = {
        role: authUserRole,
        phone: modifiedPhone,
      };
      const check_user_role_res = await check_user_role_auth(data);

      if (check_user_role_res.status === 1) {
        const res = await send_otp(data);

        if (res.status === 1) {
          navigate("/otp", {
            state: { phone: modifiedPhone },
          });
          setLoading(false);
        } else {
          toast(res.message, {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
          setLoading(false);
        }
      } else {
        toast(check_user_role_res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("error in send otp function", err);
    }
  };

  const appleResponse = (response) => {
    if (!response.error) {
      setLoginType("apple");
      setUser(response);
    }
  };

  const handel_delete_status = (message, socialData) => {
    setDeleteInfoModalText(message);
    setShowDeleteInfoModal(true);
    setSocialDataForDeleteInfo(socialData);
  };

  // NESTED COMPONENTS

  function AccountDeleteInfoModel(props) {
    const isRoleTherapist = authUserRole == "Therapist";
    const isRolePatient = authUserRole == "Patient";
    const socialData = social_data_for_delete_info;
    const naviage_fun = () => {
      if (isRoleTherapist) {
        setShowDeleteInfoModal(false);
        navigate("/therapistregisteration", {
          state: { socialData, navigateFrom: "LoginScreen" },
          replace: true,
        });
      } else if (isRolePatient) {
        setShowDeleteInfoModal(false);
        navigate("/patientregisteration", {
          state: {
            socialData,
            navigateFrom: "LoginScreen",
          },
          replace: true,
        });
      }
    };
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <p>{delete_info_modal_text}</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="delete_acc_info_modal">
            <Button
              onClick={() => {
                naviage_fun();
              }}
            >
              OK
            </Button>
            <Button
              as={Link}
              onClick={() => {
                setShowDeleteInfoModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <>
      {loading && <Loader />}
      <section
        className="loginBg"
        style={{ backgroundImage: `url(${LoginBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Form>
                <div className="loginBox">
                  <div className="text-center">
                    <Link to="/">
                      <Image
                        src={isRoleTherapist ? Logo2 : Logo}
                        className="logo"
                        alt=""
                      />
                    </Link>
                    <h1
                      style={{ marginBottom: "7px !important", marginTop: 0 }}
                    >
                      Welcome Back
                    </h1>

                    <p>Enter your phone number to proceed</p>
                  </div>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput2"
                  >
                    <Form.Label>Phone Number</Form.Label>
                    <div className="pbox">
                      <div className="callb">
                        US{" "}
                        <svg
                          width="12"
                          height="8"
                          viewBox="0 0 12 8"
                          fill="none"
                          x
                        >
                          <path
                            d="M1 1.5L6 6.5L11 1.5"
                            stroke="#212529"
                            stroke-width="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span
                          style={{
                            color: !phone.trim() ? "#929fa4" : null,
                          }}
                        >
                          +1
                        </span>
                      </div>
                      <Form.Control
                        type="text"
                        value={phone}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          setPhone(numericValue);
                        }}
                        onKeyDown={(e) => {
                          if (e.key == "Enter") {
                            e.preventDefault();
                            !validationsRes.phoneErr && send_otp_function();
                          }
                        }}
                        placeholder="(555) 000-0000"
                      />
                    </div>
                  </Form.Group>

                  <Button
                    disabled={validationsRes.phoneErr}
                    className="btn btn-primary me-3"
                    onClick={() => {
                      send_otp_function();
                    }}
                  >
                    Login
                  </Button>
                  <div className="or">
                    <span>Or</span>
                  </div>
                  <ul className="fxt-socials">
                    <li>
                      <Button
                        className="social-btn"
                        onClick={() => {
                          trackButtonClick("login_cta", { button_name: "Continue With Google", user_role: authUserRole, method: "google" });
                          login();
                          setLoginType("google");
                        }}
                      >
                        <Image src={GoogleLogo} alt="" />
                        Continue With Google
                      </Button>
                    </li>
                    {/* <li>
                      <FacebookLogin
                        appId={authContext.facebookAppId}
                        autoLoad={false}
                        fields="name,email,picture"
                        scope="public_profile,email"
                        callback={responseFacebook}
                        render={(renderProps) => {
                          return (
                            <Button
                              className="social-btn"
                              onClick={renderProps.onClick}
                            >
                              <Image src={FacebookLogo} alt="" />
                              Continue With Facebook
                            </Button>
                          );
                        }}
                      />
                    </li> */}
                    <li>
                      <AppleLogin
                        clientId={authContext.appleClientId}
                        redirectURI={process.env.REACT_APP_APPLE_REDIRECT_URL}
                        usePopup={true}
                        callback={appleResponse}
                        scope="email name"
                        responseMode="query"
                        render={(renderProps) => (
                          <Button
                            className="social-btn"
                            onClick={() => {
                              trackButtonClick("login_cta", { button_name: "Continue With Apple", user_role: authUserRole, method: "apple" });
                              renderProps.onClick();
                            }}
                          >
                            <Image src={AppleLogo} alt="" />
                            Continue With Apple
                          </Button>
                        )}
                      />
                    </li>
                  </ul>

                  <div className="links_box">
                    <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/termsofservice");
                      }}
                    >
                      Terms of Service
                    </Link>
                    <span>|</span>
                    <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/privacypolicy");
                      }}
                    >
                      Privacy Policy
                    </Link>
                    <span>|</span>
                    <Link
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/hipaa");
                      }}
                    >
                      HIPAA
                    </Link>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <AccountDeleteInfoModel show={show_delete_info_modal} />
      </section>
    </>
  );
};

export default Login;
